export const GET_USER_LIST=  '/admin/users' // 유저 목록 가져오기
export const DOWNLOAD_USER_EXCEL_FILE=  '/admin/users' // 엑셀파일 다운
export const GET_USER_MEASUREMENT_STATUS=  '/admin/users/measurement-status' // 유저별 측정 현황 (주간/월간)
